var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-wrapper"},[_c('v-slick-carousel',_vm._b({ref:"carousel"},'v-slick-carousel',_vm.settings,false),[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"dots"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }